import { useState, useEffect } from 'react';

// Navbar behavior:
// - MiniNav: sadhai visible (scrolling up ra down dubai ma)
// - Header: matra page ko top ma dekhincha; tala jada translate bhayera hide
//
// Direction detect nagarne — purely position-based (y > threshold), le
// flicker/oscillation hune chance nai chhaina.
export function useScroll(threshold = 12) {
  const [scrolled, setScrolled] = useState(false);
  // true = page top bata tala => header hide
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    let ticking = false;

    const update = () => {
      ticking = false;
      const y = window.scrollY;
      setScrolled(y > threshold);
      setHidden(y > threshold);
    };

    const onScroll = () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    update();
    return () => window.removeEventListener('scroll', onScroll);
  }, [threshold]);

  return { scrolled, hidden };
}